import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

/**
 * Processes the Emergent Auth callback fragment (#session_id=...).
 * Exchanges it for a persistent admin cookie via the backend, then redirects.
 */
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const raw = (location.hash || "").replace(/^#/, "");
    const params = new URLSearchParams(raw);
    const sid = params.get("session_id");
    if (!sid) { nav("/admin/login", { replace: true }); return; }

    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sid });
        toast.success("Welcome back.");
        // Clear the fragment before navigating so a refresh doesn't retry
        window.history.replaceState({}, document.title, window.location.pathname);
        nav("/admin", { replace: true });
      } catch (err) {
        const msg = err?.response?.data?.detail || "Sign-in failed.";
        toast.error(msg);
        nav("/admin/login", { replace: true });
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[--sanctum-bg]">
      <div className="text-center">
        <div className="w-10 h-10 rounded-full border-2 border-neutral-200 border-t-neutral-900 animate-spin mx-auto mb-4" />
        <p className="font-display text-xl">Signing you in…</p>
      </div>
    </div>
  );
}
